import {
  NodoDto,
  ProprietaMisurataDto,
  useGetRegistriDispositivo,
} from "@/api";
import Box from "@/elements/Box";
import Button from "@/elements/Button";
import Typography from "@/elements/Typography";
import { Card, Grid } from "@mui/material";
import ProprietaMisurataLabel from "../../../ProprietaMisurataLabel";
import { getMascheraDispositivoHelper } from "@/components/DispositivoDetails/maschere";
import { useMemo } from "react";
import Loading from "@/components/Loading";
import numeral from "numeral";

function ProprietaFFTMisurateCard({
  dispositivo,
  proprietaMisurate,
  openHistoryDialog,
}: {
  dispositivo: NodoDto;
  proprietaMisurate: ProprietaMisurataDto[];
  openHistoryDialog: () => void;
}) {
  return (
    <Card sx={{ width: 332, height: 304 }}>
      <Box
        p={2}
        display="flex"
        flexDirection="column"
        alignItems="center"
        flex={1}
        height="100%"
      >
        <Typography variant="body2" fontWeight="medium" color="text">
          FFT (mm/s)
        </Typography>

        <Box
          display="flex"
          alignItems="center"
          mb={1}
          flexDirection="column"
          justifyContent="center"
          height="100%"
        >
          <Grid
            container
            rowSpacing={1}
            columnSpacing={2}
            sx={{
              justifyContent: "center",
              alignItems: "flex-start",
            }}
          >
            {proprietaMisurate.map((proprietaMisurata, index) => (
              <Grid item xs={6} key={index}>
                <ProprietaMisurataLabel
                  dispositivo={dispositivo}
                  proprietaMisurata={proprietaMisurata}
                  value={proprietaMisurata.lastValue || null}
                  alignItems="center"
                  skipMeasureUnit
                  typographyVariantPrimary="h5"
                />
              </Grid>
            ))}
          </Grid>
        </Box>

        <Box width="100%" display="flex" flexDirection="row" mt="auto">
          <Button
            variant="textArrow"
            color="text"
            sx={{ ml: "auto", mr: 0, mt: 1, mb: -1 }}
            onClick={openHistoryDialog}
          >
            Vedi storico
          </Button>
        </Box>
      </Box>
    </Card>
  );
}

export default ProprietaFFTMisurateCard;
